module.exports = __webpack_public_path__ + "img/hetong.e85eacc0.png";